import type { z } from "zod";
import type { RouteName, Routes } from "@ai-platform/contracts";

/*
 * Query keys follow the route catalogue (ADR-076): `[routeName, params, query]`. One route is one
 * key prefix, so a mutation invalidates every page and filter of a list with `[routeName]`.
 */

/** Routes that read: GET with a response schema. The browser redirect `loginCallback` is none. */
export type QueryRouteName = {
  [N in RouteName]: Routes[N] extends { method: "GET"; response: z.ZodType } ? N : never;
}[RouteName];

/** Routes that change something: every method but GET. */
export type MutationRouteName = {
  [N in RouteName]: Routes[N]["method"] extends "GET" ? never : N;
}[RouteName];

export type RouteKey = readonly [QueryRouteName, Record<string, string>, Record<string, unknown>];

/** The key of one read: route, path parameters, query. Empty objects when there are none. */
export function routeKey(
  name: QueryRouteName,
  params: Record<string, string> = {},
  query: Record<string, unknown> = {},
): RouteKey {
  return [name, params, query] as const;
}
